import dynamic from 'next/dynamic';
import React from 'react';

const Vitality = dynamic(() => import('@members/pg-vitality/VitalityPage'), {
  ssr: false,
});

export default function VitalityPage() {
  return <Vitality />;
}
